export default class AddTimesheetsToInvoiceRequest {
  public timesheetIds: string[] = [];
}
